export default __webpack_public_path__ + "static/media/boba-mobile-share-modal-bottom-ribbon.983e0e3c.svg";